module.exports = __webpack_public_path__ + "assets/img/D3-Security-Landing-Page-+-Website.0413426a.jpg";